import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { sendProComFollowUp, getRegisteredListPaged, getTotalRegistered, exportWcSubscribers,removethisItem, blockThisUser, unBlockThisUser } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';

import DataTable from 'react-data-table-component';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';

import BeWiseLoading from '../../../../src/assets/bewiseloading.gif';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';


class registeredUsersList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      exportbtndisabled:false,  
      thisExportBtnText:'Export',
      selected_teacher:'',
      blocked:false
    }

    this.getTotal = this.getTotal.bind(this);
    this.getList = this.getList.bind(this);
    this.blockUser = this.blockUser.bind(this);
    this.cancelModal = this.cancelModal.bind(this);
    this.submitBlockUser = this.submitBlockUser.bind(this);


  }


    getTotal = (vertical, location='') => {

      const { login_id, role } = this.state.auth_data;

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        vertical: vertical,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotalRegistered(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    }  

  componentDidMount() {

          var THIS = this;
      $(document).on('click', '.dlte', function () {
        var delete_id = $(this).data("id");
        
        if(confirm("You are sure to delete?")==true){

          let ins = JSON.stringify({
            id: delete_id,
            table:'wiseconnect'
          });

          removethisItem(ins).then((res) => {

            if(res.status==1){
              NotificationManager.success('Removed successfully');
            }else{
              NotificationManager.error('Issue in removing');
            }
            this.getTotal('leads');
            this.getList();

          });

      }


      });
      
      this.getTotal('leads');
      this.getList();

  }

  sendProComFolwup(lead_id){

    let ins = JSON.stringify({
      lead_id:lead_id
    });

    sendProComFollowUp(ins).then((res) => {

      this.setState({loading:true});

      if (res.status == 1) {

        NotificationManager.success('Profile completion follow-up mail has been sent successfully');
      }
      else{
        NotificationManager.error('Profile completion follow-up mail is not sent');
      }

    })

  }

   
  

      getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        perpage:this.state.PER_PAGE,
        year: this.state.year,
        month: this.state.month,
        offset:newOffset
      });

      getRegisteredListPaged(ins).then((res) => {

        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          

            const newLeads = res.data.map((lead) => ({
                "id": lead.id,
                "email": lead.email,
                "name" : lead.name,
                "phonenumber" : lead.phonenumber,
                "pre_registered" : lead.pre_registered,
                "status" : lead.status,
                "professionalprofile": lead.professionalprofile,
                "personalprofile" : lead.personalprofile,
                "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
            }));

            this.setState({ list: newLeads});


        } else {

              this.setState({loading:!this.state.loading});
              
              this.setState({
                list: [],
              });
        }
      });


    }  
 

    blockUser(teacher_id){
      
      this.setState({blockmodal:true, selected_teacher:teacher_id});

      
    }

    cancelModal(){
      
      this.setState({blockmodal:false, selected_teacher:''});

    }

    unBlockUser(teacher_id){

      let ins = JSON.stringify({
        teacher_id:teacher_id
      });

      unBlockThisUser(ins).then((res) => {

        if(res.status==1){
          NotificationManager.success('Unblocked successfully');
        }else{
          NotificationManager.error('Issue in unblocking');
        }

      });

    }

    submitBlockUser(){

      const teacher_id = this.state.selected_teacher;

      let ins = JSON.stringify({
        teacher_id:teacher_id
      });

      blockThisUser(ins).then((res) => {

            if(res.status==1){
              this.setState({blocked:true});
            }else{
              this.setState({blocked:false});
            }
           

      });


    }

    handlePageChange(pageNumber) {

          console.log(`active page is ${pageNumber}`);

          this.setState({activePage: pageNumber});

          //this.getTotal('bw_schools');
          this.getList(pageNumber);


    }   


  subscribersExport = async () => {

    this.setState({exportbtndisabled:true, thisExportBtnText:"exporting..."});

    try {
      let req = JSON.stringify({
        location: this.state.location
      })
      const res = await exportWcSubscribers(req);
      if (res.status == 1) {

        this.setState({exportbtndisabled:false, thisExportBtnText:"Export"});
        console.log('location_list', res)
        console.log('location_list', res.path)
        window.open(res.path)

        // this.setState({
        //   subscribe_list: res.results,
        // });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  }      
 
  render() {
        const { list } = this.state;
        const { currentPage, PER_PAGE, totalCount, total, exportbtndisabled } = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                 
                 <h4 class="card-title">List</h4>
                   
                 <div class="float-right"><button disabled={exportbtndisabled} class="btn btn-primary btn-sm"  onClick={() => this.subscribersExport()}>{this.state.thisExportBtnText}</button></div>
                
                 <div class="table-responsive pt-3">
                     <table class="table table-bordered table-sm">
                      <thead  class="thead-dark">
                        <tr>
                         
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Email Id</th>
                          <th>Phonenumber</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Personal</th>
                          <th>Professional</th>
                          <th>Early Bird?</th>
                          <th>Action</th>                          
                        </tr>
                      </thead>
                      <tbody>
                      {list.length>0 && list.map((lead, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          <td>{lead.name}</td>  
                          <td>{lead.email}</td>
                          <td>{lead.phonenumber}</td>
                          <td>{lead.createdAt}</td>
                          <td className={lead.status==1?"active":(lead.status==3)?"blocked":"inactive"}><b>{(lead.status=="1")? "Active":(lead.status=="3")?"Blocked":"Not Verified Yet"}</b></td>
                          <td><b>{lead.personalprofile}% complete</b></td>
                          <td><b>{lead.professionalprofile}% complete</b></td>
                          <td>{lead.pre_registered==1?"Yes":"No"}</td>
                          <td>
                           <a href={"/wiseconnect/viewprofile/"+lead.id}  class="btn btn-primary btn-sm">View</a>&nbsp;

                           { /*
                          {lead.status=="1" &&
                            <button class="btn btn-primary btn-sm" onClick={()=>this.blockUser(lead.id)}>Block</button>
                          }
                          {lead.status=="3" &&
                            <button class="btn btn-primary btn-sm" onClick={()=>this.unBlockUser(lead.id)}>Unblock</button>
                          }
                            &nbsp;<button class="btn btn-primary btn-sm" onClick={()=>this.sendProComFolwup(lead.id)}>manual follow-up</button>
                            &nbsp;<button class="btn btn-primary btn-sm dlte" data-id={lead.id}>Remove</button>
                          */ }
                          </td>
                        </tr>

                      })

                      }

                      {list.length==0 && 

                      <tr><td colSpan="6">No data</td></tr>
                       }
                       
                      </tbody>
                    </table>


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>

                  </div>
                    
 
                </div>
              </div>
            </div>  <NotificationContainer/>


            <Modal size="sm" style={{maxWidth: '450px', width: '100%'}}  isOpen={this.state.blockmodal} className="modalpopup">
        <ModalHeader>Blocking User Access</ModalHeader>
         <ModalBody>
                        {!this.state.blocked &&
                        <div>
                        <div class="areyousure">Are you sure that you want to block this user access?</div>
                        <div class="btnblockflex">

                          <div><button class="btn btn-main" onClick={this.submitBlockUser}>Yes</button></div>
                          <div><button class="btn btn-main" onClick={this.cancelModal}>No</button></div>

                        </div>
                        </div>
                        }

                        {this.state.blocked &&
                        <div>
                        <div class="areyousure">Successfully We have blocked this user!</div>
                        <div class="btnblockflex">
                          <div><button class="btn btn-main" onClick={this.cancelModal}>Close</button></div>
                        </div>
                        </div>
                        }
              </ModalBody>
            </Modal>
                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default registeredUsersList;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/registeredUserList.jsx